import { apiCallWithToken } from "../components/apiCallWithToken";
import { IGetUsersAsAdmin } from "./types";

export const getUsersAsAdmin = async (currentPage: number, status: 'confirmed' | "unconfirmed", searchedWord?: string) => {
    try {
        const resp: IGetUsersAsAdmin = await apiCallWithToken(
            `/admin/users?user_status=${status}&q=${searchedWord || ''}&page=${currentPage}`,
        );
        return resp;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const deleteUser = async (userId: string) => {
    try {
        const resp = await apiCallWithToken(`/admin/users/${userId}`, 'DELETE');
        return resp;
    } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
    }
}

export const changeUserAccess = async (userId: string, canAccess: boolean) => {
    try {
        const resp = await apiCallWithToken(`/admin/users/${userId}/change-access?website_id=1&can_access=${canAccess}`, 'PATCH');
        return resp;
    } catch (error) {
        console.error("Error disabling user:", error);
        throw error;
    }
}

export const acceptUser = async (userId: string) => {
    try {
        const resp = await apiCallWithToken(`/admin/users/${userId}/change-status?new_status=confirmed`, 'PATCH');
        return resp;
    } catch (error) {
        console.error("Error accepting user:", error);
        throw error;
    }
}

export const changeUserGroup = async (userId: string, userGroup: string) => {
    try {
        const resp = await apiCallWithToken(`/admin/users/${userId}/change-group?new_group=${userGroup}`, 'PATCH');
        return resp;
    } catch (error) {
        console.error("Error changing user group:", error);
        throw error;
    }
}